<template>
  <v-layout>
    <v-flex>
      <v-select
        v-if="!isLoading"
        :items="items"
        v-model="model"
        :label="label"
        item-text="display"
        item-value="id"
        :disabled="disabled"
      ></v-select>
    </v-flex>
    <v-flex align-self-center>
      <v-btn fab dark small color="accent" @click="newCard=!newCard">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-flex>
    <card-form
      :open="newCard"
      :customerId="customerId"
      v-on:add="newCard=!newCard;getClientCard()"
      v-on:cancel="newCard=!newCard"
    ></card-form>
  </v-layout>
</template>

<script>
import CardForm from "./CardForm.vue";

export default {
  components: {
    CardForm
  },
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: [],
      newCard: false
    };
  },
  props: ["value", "label", "customerId", "disabled"],
  watch: {
    model() {
      this.$emit("input", this.model);
    },
    locationId() {
      this.getClientCard();
    }
  },
  mounted: function() {
    this.getClientCard();
  },
  methods: {
    getClientCard() {
      if (this.customerId) {
        this.$store
          .dispatch("clients/card", {
            customerId: this.customerId
          })
          .then(data => {
            this.items = data;
          })
          .finally(() => (this.isLoading = false));
      }
    }
  }
};
</script>

<style>
</style>
